export default __webpack_public_path__ + "static/2-14f8174b0ef7802ee46fffb43c8afc87.png";